export default __webpack_public_path__ + "static/media/settings_button.d5bd6fbd.svg";